import Vue from 'vue'
import Vuex from 'vuex'
import moduleIO from '@/store/modules/io'
import moduleData from '@/store/modules/data'
import moduleLanguages from '@/store/modules/languages'
import moduleReports from '@/store/modules/reports'
import moduleInventory from '@/store/modules/inventory'
import moduleInterface from '@/store/modules/interface'
import modulePack from '@/store/modules/pack'
import moduleMass from '@/store/modules/mass'
import moduleOrderNovelty from '@/store/modules/orderNovelty'
import auth from '@my/authentication'

Vue.use(Vuex)

const filters = {}
const collections = ['users', 'colors', 'designs', 'articles', 'methods', 'conveyors', 'images', 'codes', 'locations', 'articleDefaults', 'products', 'sizes', 'labels', 'tiers', 'temporaryStocks', 'orders', 'deliveries', 'prices', 'orderWholesalers', 'ordersDropshipping', 'refunds', 'invoices', 'configs', 'changes', 'giftVouchers', 'sets', 'giftMessages', 'bonuses', 'customers', 'faqs', 'feedbacks', 'bans', 'fraudCases', 'fraudCasesClosed', 'fraudReports']

const collectionsRestricted = ['orders', 'orderWholesalers', 'ordersDropshipping', 'changes', 'deliveries', 'refunds', 'invoices', 'images']

const createCollections = () => {
  collections.forEach(collection => {
    const dateRange = collectionsRestricted.includes(collection) ? 'last6Months' : 'last10Years'
    filters[collection] = {
      expand: false,
      limit: 10,
      order: '-',
      search: '',
      searchBy: '',
      search1: '',
      searchBy1: '',
      sort: 'createdAt',
      init: '',
      final: '',
      dateRange: dateRange
    }
    filters[`${collection}History`] = {
      expand: false,
      limit: 10,
      order: '-',
      search: '',
      searchBy: '',
      search1: '',
      searchBy1: '',
      sort: 'updatedAt',
      init: '',
      final: '',
      dateRange: dateRange
    }
  })
}

createCollections()

export default new Vuex.Store({
  state: {
    trackingDeliveries: [],
    company: '',
    variables: {},
    user: {
      name: '',
      type: '',
      logged: false
    },
    messages: [],
    idMessage: 0,
    loader: {
      message: '',
      state: '',
      show: false
    },
    listNames: {},
    list: {
      limits: [5, 10, 20, 50, 100],
      users: {
        sortByFields: ['updatedAt', 'createdAt', 'name', 'type'],
        searchBy: ['name', 'type']
      },
      usersHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['dni', 'createdBy', 'updatedBy']
      },
      colors: {
        sortByFields: ['updatedAt', 'createdAt', 'color', 'spanish'],
        searchBy: ['color', 'spanish']
      },
      colorsHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['color', 'spanish']
      },
      articles: {
        sortByFields: ['updatedAt', 'createdAt', 'article', 'spanish'],
        searchBy: ['article', 'spanish']
      },
      articlesHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['article', 'spanish']
      },
      faqs: {
        sortByFields: ['updatedAt', 'createdAt', 'faq', 'question', 'brand'],
        searchBy: ['faq', 'question', 'brand']
      },
      feedbacks: {
        sortByFields: ['updatedAt', 'createdAt', 'feedback', 'description', 'type', 'status', 'createdBy'],
        searchBy: ['feedback', 'description', 'type', 'status', 'createdBy']
      },
      designs: {
        sortByFields: ['updatedAt', 'createdAt', 'design'],
        searchBy: ['design']
      },
      designsHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['design']
      },
      images: {
        sortByFields: ['updatedAt', 'createdAt', 'image', 'dir'],
        searchBy: ['image', 'dir']
      },
      imagesHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['image', 'folder']
      },
      codes: {
        sortByFields: ['updatedAt', 'createdAt', 'code'],
        searchBy: ['code']
      },
      config: {
        sortByFields: ['updatedAt', 'createdAt', 'config'],
        searchBy: ['config']
      },
      codesHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['code']
      },
      methods: {
        sortByFields: ['updatedAt', 'createdAt', 'method'],
        searchBy: ['method']
      },
      methodsHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['method']
      },
      conveyors: {
        sortByFields: ['updatedAt', 'createdAt', 'conveyor'],
        searchBy: ['conveyor']
      },
      conveyorsHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['conveyor']
      },
      locations: {
        sortByFields: ['updatedAt', 'createdAt', 'location', 'deparment'],
        searchBy: ['location', 'department']
      },
      locationsHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['location', 'department']
      },
      articleDefaults: {
        sortByFields: ['updatedAt', 'createdAt', 'articleDefault', 'person', 'design'],
        searchBy: ['articleDefault', 'person']
      },
      articleDefaultsHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['articleDefault', 'person', 'design']
      },
      products: {
        sortByFields: ['updatedAt', 'createdAt', 'product', 'article', 'person', 'design', 'totalAvailable', 'brand'],
        searchBy: ['product', 'article', 'person', 'design', 'errorStock', 'colors', 'brand', 'description', 'isClearence']
      },
      productsHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['product', 'article', 'person', 'design']
      },
      sizes: {
        sortByFields: ['updatedAt', 'createdAt', 'size'],
        searchBy: ['size']
      },
      sizesHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['size']
      },
      labels: {
        sortByFields: ['updatedAt', 'createdAt', 'label'],
        searchBy: ['label']
      },
      labelsHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['label']
      },
      tiers: {
        sortByFields: ['updatedAt', 'createdAt', 'tier'],
        searchBy: ['tier', 'shelf', 'name', 'warehouse']
      },
      tiersHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['tier', 'shelf', 'name', 'warehouse']
      },
      temporaryStocks: {
        sortByFields: ['updatedAt', 'createdAt', 'temporaryStock'],
        searchBy: ['temporaryStock']
      },
      temporaryStocksHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['temporaryStock']
      },
      orders: {
        sortByFields: ['updatedAt', 'createdAt', 'temporaryStock'],
        searchBy: ['order', 'name', 'dni', 'phones', 'email', 'status', 'location', 'department', 'adviser', 'methodPay', 'deliveries', 'brand', 'isWholesaler', 'paidWholesaler', 'address', 'codeName', 'conveyor']
      },
      changes: {
        sortByFields: ['updatedAt', 'createdAt', 'temporaryStock'],
        searchBy: ['order', 'change', 'name', 'dni', 'phones', 'email', 'status', 'location', 'brand']
      },
      ordersDropshipping: {
        sortByFields: ['createdAt'],
        searchBy: ['order', 'name', 'dni', 'phones', 'email', 'status', 'location']
      },
      ordersHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['order']
      },
      deliveries: {
        sortByFields: ['updatedAt', 'createdAt', 'temporaryStock'],
        searchBy: ['delivery', 'order', 'nameRecipient', 'nameDeliveryMan', 'locationRecipient', 'dniDeliveryMan', 'status', 'conveyor', 'paidBy', 'collectedBy', 'tracking', 'phonesRecipient', 'brand']
      },
      deliveriesHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['delivery']
      },
      refunds: {
        sortByFields: ['updatedAt', 'createdAt', 'temporaryStock'],
        searchBy: ['refund', 'order', 'status', 'method', 'brand', 'phones', 'packReceived']
      },
      refundsHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['refund']
      },
      invoices: {
        sortByFields: ['updatedAt', 'createdAt', 'temporaryStock'],
        searchBy: ['order', 'status', 'tascode']
      },
      invoicesHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['order']
      },
      prices: {
        sortByFields: ['updatedAt', 'createdAt', 'price'],
        searchBy: ['price']
      },
      pricesHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['price']
      },
      orderWholesalers: {
        sortByFields: ['updatedAt', 'createdAt', 'temporaryStock'],
        searchBy: ['order', 'name', 'dni', 'phones', 'status', 'location']
      },
      ordersDropshiping: {
        sortByFields: ['updatedAt', 'createdAt', 'temporaryStock'],
        searchBy: ['order', 'name', 'dni', 'phones', 'status', 'location']
      },
      orderWholesalersHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['order']
      },
      giftVouchers: {
        sortByFields: ['updatedAt', 'createdAt', 'phone', 'methodPay'],
        searchBy: ['status', 'name', 'phone']
      },
      giftMessages: {
        sortByFields: ['updatedAt', 'createdAt', 'phone', 'name'],
        searchBy: ['order', 'name', 'phone']
      },
      sets: {
        sortByFields: ['updatedAt', 'createdAt', 'id', 'order'],
        searchBy: ['id', 'order', 'images', 'products']
      },
      bonuses: {
        sortByFields: ['updatedAt', 'createdAt', 'bonus', 'phone', 'status', 'type'],
        searchBy: ['bonus', 'order', 'phone', 'status', 'type', 'changeId', 'brand', 'packReceived']
      },
      bonusesHistory: {
        sortByFields: ['updatedAt', 'createdAt', 'createdBy', 'updatedBy'],
        searchBy: ['bonus', 'phone']
      },
      customers: {
        sortByFields: ['updatedAt', 'createdAt', 'phone', 'name'],
        searchBy: ['phone', 'name', 'email', 'dni', 'active']
      },
      bans: {
        sortByFields: ['updatedAt', 'createdAt', 'type', 'value', 'name', 'order'],
        searchBy: ['value', 'type', 'name', 'order']
      },
      fraudCases: {
        sortByFields: ['updatedAt', 'createdAt', 'number', 'originOrder', 'triggerLine', 'riskLevel', 'status'],
        searchBy: ['originOrder', 'triggerLine', 'riskLevel', 'status', 'brand']
      },
      fraudCasesClosed: {
        sortByFields: ['updatedAt', 'createdAt', 'closedAt', 'number', 'originOrder', 'triggerLine', 'riskLevel'],
        searchBy: ['originOrder', 'triggerLine', 'riskLevel', 'brand']
      },
      fraudReports: {
        sortByFields: ['createdAt', 'number', 'status', 'trigger', 'ordersAnalyzed', 'ordersFlagged'],
        searchBy: ['status', 'trigger', 'triggeredBy']
      }
    },
    filters,
    folders: ['images', 'products', 'methods', 'conveyors', 'articles', 'others'],
    persons: [
      { person: 'man', letter: 'h' },
      { person: 'woman', letter: 'w' },
      { person: 'boy', letter: 'b' },
      { person: 'girl', letter: 'g' },
      { person: 'adults', letter: 'a' },
      { person: 'children', letter: 'c' },
      { person: 'all', letter: 't' }
    ],
    print: {
      label: {},
      products: [],
      returnAddressOrders: null,
      returnAddressChanges: null,
      returnAddressRemitOnly: false
    },
    shelfs: ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 's9', 's10', 's11', 's12', 's13', 's14', 's15', 's16', 's17', 's18', 's19', 's20', 's21', 's22', 's23', 's24', 's25', 's26', 's27', 's28', 's29', 's30', 's31', 's32', 's33', 's34', 's35', 's36', 's37', 's38', 's39', 's40', 's41', 's42', 's43', 's44', 's45', 's46', 's47', 's48', 's49', 's50', 's51', 's52', 's53', 's54', 's55', 's56', 's57', 's58', 's59', 's60', 's61', 's62', 's63', 's64', 's65', 's66', 's67', 's68', 's69', 's70', 's71', 's72', 's73', 's74', 's75', 's76', 's77', 's78', 's79', 's80', 's81', 's82', 's83', 's84', 's85', 's86', 's87', 's88', 's89', 's90', 's91', 's92', 's93', 's94', 's95', 's96', 's97', 's98', 's99', 's100'],
    warehouses: ['w1', 'w2', 'w3', 'w4', 'w5', 'w6', 'w7', 'w8', 'w9', 'w10']
  },

  mutations: {
    setDeliveriesTracking (state, tracking) {
      state.trackingDeliveries = tracking
    },

    showMessage (state, message) {
      const id = state.idMessage

      message.id = id
      if (!message.type) message.type = 'ok'

      state.messages.unshift(message)
      ++state.idMessage

      setTimeout(() => {
        const index = state.messages.findIndex(message => message.id === id)
        if (index >= 0) state.messages.splice(index, 1)
      }, 7000)
    },

    deleteMessage (state, id) {
      const index = state.messages.findIndex(message => message.id === id)
      if (index >= 0) state.messages.splice(index, 1)
    },

    showLoader (state, loader) {
      state.loader = loader
    },
    hideMessage (state, message) {
      state.message.show = false
    },
    hideLoader (state, loader) {
      state.loader.show = false
    },
    saveFunctionMessage (state, functionModal) {
      state.message.function = functionModal
    },
    removeFunctionMessage (state) {
      state.message.function = false
    },
    setUserDNI (state, dni) {
      state.user.dni = dni
    },
    login (state, token) {
      if (!token) {
        token = auth.getToken()
      } else {
        auth.setToken(token)
      }

      if (token) {
        const payload = auth.getPayload(token)
        const { name, type, dni } = payload

        state.user = { dni, name, type, logged: true }
      }
    },
    logout (state) {
      auth.removeToken()
      state.user = { dni: '', name: '', type: '', logged: false }
    },
    setConfigPage (state, options) {
      const { resolver, key, value } = options
      state.filters[resolver][key] = value
    },
    setName (state, user) {
      state.listNames[user.dni] = user.name
    },
    setLabel (state, label) {
      state.print.label = label
    },
    initProductLabel (state) {
      state.print.products = []
    },
    setProductLabel (state, product) {
      state.print.products.push(product)
    },
    setPrintReturnAddress (state, { orders, changes, remitOnly = false }) {
      state.print.returnAddressOrders = orders || null
      state.print.returnAddressChanges = changes || null
      state.print.returnAddressRemitOnly = remitOnly
    },
    clearPrintReturnAddress (state) {
      state.print.returnAddressOrders = null
      state.print.returnAddressChanges = null
      state.print.returnAddressRemitOnly = false
    },
    assingDelivery (state) {
      if (state.user.type === 'delivery') {
        state.filters.deliveries.search = `${state.user.dni}`
        state.filters.deliveries.searchBy = 'dniDeliveryMan'
        state.filters.deliveries.limit = 50
        state.filters.deliveries.sort = 'createdAt'
      }
    },
    updateBalance (state, balance) {
      state.variables.balance = balance
    },
    filterOutside (state, { collection, search, searchBy }) {
      state.filters[collection].search = search
      state.filters[collection].searchBy = searchBy
    }
  },

  modules: {
    socket: moduleIO,
    data: moduleData,
    languages: moduleLanguages,
    reports: moduleReports,
    inventory: moduleInventory,
    interface: moduleInterface,
    pack: modulePack,
    mass: moduleMass,
    orderNovelty: moduleOrderNovelty
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js